import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../helpers/string-helper';
import * as moment from 'moment';

@Pipe({
  name: 'displayDateTime'
})
export class DisplayDateTimePipe implements PipeTransform {
  transform(
    date: Date,
    time: Date,
    dateFormat = 'DD/MM/YYYY',
    timeFormat = 'HH:mm',
    long = false
  ) {
    return StringHelper.join(
      [
        date == null
          ? null
          : `${long ? ' op ' : ''}${moment(date).format(dateFormat)}`,
        time == null
          ? null
          : `${long ? ' om ' : ''}${moment(time, 'HH:mm:ss').format(
              timeFormat
            )}`
      ],
      ' '
    );
  }
}
